module.exports = __webpack_public_path__ + "media/assets/images/sales-processes-add-80a8ace9767013f6825d9808499a4cda.png";